import React from "react";
import PropTypes from 'prop-types';

const Viewer = ({ isLoading, base64 }) => {
  const base64Prefix = "data:application/pdf;base64,";
  
  const fullBase64 = base64.startsWith(base64Prefix) ? base64 : `${base64Prefix}${base64}`;

  if (!isLoading && !fullBase64) {
    return <p className="text-red-500 text-center">No hay documento disponible.</p>;
  }

  return (
    <div className="w-full h-[600px] flex items-center justify-center">
      {isLoading ? (
        <div className="skeleton animate-pulse w-full h-[600px] flex items-center justify-center bg-gray-200 text-gray-500" aria-busy="true">
          Cargando PDF...
        </div>
      ) : (
        <iframe
          src={fullBase64}
          width="100%"
          height="600px"
          title="Visor de PDF"
          className="border rounded-lg shadow-md"
        />
      )}
    </div>
  );
};

Viewer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  base64: PropTypes.string.isRequired,
};

export default Viewer;
